import React, { useState } from "react";
import PageHeader from "../../components/common/PageHeader";
import FormActions from "../../components/common/FormActions";

const SingleContentPage = ({ title, moduleKey }) => {
  const [formData, setFormData] = useState({
    title: title,
    slug: moduleKey,
    shortDescription: "",
    content: "",
    seoTitle: "",
    seoDescription: "",
    status: "published",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Saved page:", formData);
  };

  return (
    <div className="single-content-page">
      <PageHeader title={title} subtitle={`Manage ${title} content`} />
      <form className="admin-form" onSubmit={handleSubmit}>
        <div className="card">
          <div className="form-grid">
            <div className="form-group">
              <label>Page Title</label>
              <input name="title" value={formData.title} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Slug</label>
              <input name="slug" value={formData.slug} onChange={handleChange} />
            </div>
            <div className="form-group full-width">
              <label>Short Description</label>
              <textarea name="shortDescription" rows="3" value={formData.shortDescription} onChange={handleChange} />
            </div>
            <div className="form-group full-width">
              <label>Content</label>
              <textarea name="content" rows="10" value={formData.content} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>SEO Title</label>
              <input name="seoTitle" value={formData.seoTitle} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Status</label>
              <select name="status" value={formData.status} onChange={handleChange}>
                <option value="published">Published</option>
                <option value="draft">Draft</option>
              </select>
            </div>
            <div className="form-group full-width">
              <label>SEO Description</label>
              <textarea name="seoDescription" rows="3" value={formData.seoDescription} onChange={handleChange} />
            </div>
          </div>
        </div>
        <FormActions />
      </form>
    </div>
  );
};

export default SingleContentPage;
